import EventsListingCard from "../../event-view-all-page/EventsListingCard";
import ShowSuccess from "../show-success";
import "./package-lead-submitted.css"
import footer1 from '../../Footer/image/footer1.png'
import footer2 from '../../Footer/image/footer2.png'
import promotion from '../../event-view-all-page/image/promotion.webp'
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from 'axios';
import Accordion from "../../CRP/components/Accordion";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { BsWhatsapp } from "react-icons/bs";
import { API_BASE_URL } from "../../utils";

const faqs = [
    {
        question: "What happens after I make a group booking?",
        answer: `Once you complete your booking, our team will verify the details and share confirmation along with all event access information via WhatsApp and email within 30 minutes.`,
    },
    {
        question: "How do I receive my booking confirmation?",
        answer: "Your booking confirmation will be sent via WhatsApp and email. Please check your spam folder in case you don’t see it in your inbox."
    },
    {
        question: "Can I make changes to my group size later?",
        answer: "Yes, minor adjustments (up to ±2 people) can be made by contacting our support team at least 24 hours before the event.",
    },
    {
        question: "Will I get a reserved table or entry only?",
        answer: "Your group booking includes priority table allocation (based on availability) and guaranteed entry. Exact table placement is shared before the event.",
    },
    {
        question: "What if I don’t receive a confirmation?",
        answer: "If you haven’t received a confirmation within 30 minutes, please reach out to our support team on WhatsApp",
    },
    {
        question: "Can I add special requests (cake, décor, etc.)?",
        answer: "Absolutely! You can share special requests through WhatsApp after booking, and we’ll coordinate with the venue for custom arrangements.",
    },
    {
        question: "How early should we arrive at the venue?",
        answer: "We recommend arriving 15–20 minutes early to ensure smooth entry and seating for your group.",
    },
];

const url = `${API_BASE_URL}/master/assets/uploads/`;


export default function PackageLeadSubmitted() {

    // const userData = JSON.parse(localStorage.getItem('userData'));

    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        // Helper to get ordinal suffix
        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${day}${getOrdinal(day)}, ${month} ${year}`;
    };

    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubEvent/upcomingEvents`,
                formData
            );

            if (response.data.status === true) {
                console.log('Upcoming Events:', response.data.data);
                setEventData(response.data.data); // ✅ Save to state
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today);
                },
                (error) => {
                    // alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);



    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }

    const [openIndex, setOpenIndex] = useState(null);
    const handleFAQtoggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };


    return (
        <div className="package-lead-submitted-container">
            <ShowSuccess
                message='Woohoo! Your Group Party Request is In'
                thanksyouMessage="We’ve received your booking details. Our team will reach out shortly to finalize your venue, offers & add-ons."
            />


            <div className="event-cards-container">
                <div className='event-detail-page-design-bottom-promotional-banner'>
                    <div className='event-detail-page-design-bottom-promotional-banner-content'>
                        <div className='event-detail-page-design-bottom-promotional-banner-content-heading'>
                            <h1>🎉 Get 500 carrots🥕 instantly → Download the App</h1>
                        </div>
                        <div className='event-detail-page-design-bottom-promotional-banner-content-images'>
                            <a href="https://apps.apple.com/in/app/partywitty/id6478442502">
                                <img src={footer1} alt="" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                <img src={footer2} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className='event-detail-page-design-bottom-promotional-banner-image'>
                        <img src={promotion} alt="" />
                    </div>
                </div>
            </div>


            <div className="event-cards-container">
                <div className="event-happening-title">
                    <h1>Events happening on {formatDate(today)}</h1>
                    <Link to='/today-events'>
                        <p>view all</p>
                    </Link>
                </div>
                <div className="event-cards-thank-you-page">
                    {eventsData.slice(0, 3).map((event, index) => (
                        <Link to={generateClubUrl(event.clubName, event.cityName, event.areaName, event.name)} key={index} >
                            <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer}
                                eventid={event.id} clubid={event.club_id} />
                        </Link>
                    ))}
                </div>
            </div>
            <div className="event-cards-container">
                <div className='event-detail-page-design-content-section-faq-heading' onClick={() => { handleFAQtoggle(1) }}>
                    <h2>Frequently asked questions</h2>
                    {openIndex === 1 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>

                {openIndex === 1 && (
                    <Accordion faqs={faqs} />
                )}
            </div>

            <a href="https://wa.me/+918299619469" target="_blank">
                <div className="rbfssp-whatsapp-section">
                    <BsWhatsapp className="rbfssp-whatsapp-icon" />
                </div>
            </a>
        </div>
    )

}